<div class="sales-approval-container">
  <h2>Stock Check Approval</h2>

  <div class="toolbar">
        <button (click)="selectall()">✅ SelectAll</button>
    <button (click)="loadData()">🔄 Refresh</button>
   <button (click)="sales()">✅ Approve</button>   <!--"approveSelected()" -->
    <button (click)="rejectSelected()">❌ Reject</button>
  </div>

  <table class="styled-table" border="1">
    <thead>
      <tr>
        <th>Select</th>
        <th>#</th>
        <th>BarCode</th>
        <th>Item Name</th>
        <th>Employer Name</th>
        <th>software stock</th>
        <th>In stock</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let sale of salesList; let i = index">
        <td><input type="checkbox" (change)="toggleSelection(sale)" [(ngModel)]="sale.selected" /></td>
        <td>{{ i + 1 }}</td>
        <td>{{ sale.Barcode }}</td>
        <td>{{ sale.Itemname }}</td>
        <td>{{ sale.Employeename }}</td>
        <td>{{ sale.Actual_Qty }}</td>
        <td>{{ sale.Instock }}</td>
      </tr>
      <tr *ngIf="salesList.length === 0">
        <td colspan="7" style="text-align:center;">No stock check data available</td>
      </tr>
    </tbody>
  </table>
</div>
